import { useQuery } from 'react-query';
import axios from 'axios';
import { INDEX_PAGE } from './useInvoices'; // item 1480 — whole index, not a 100-row page
import { ProposalsDto } from '../models/proposal';

export const getProposals = async (): Promise<ProposalsDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}proposal/Search`, { params: { pageSize: INDEX_PAGE } });
  return data;
};

const useProposals = () => useQuery('proposals', getProposals);

export default useProposals;
